import React from 'react';
import { Headphones, Mail, ExternalLink, CheckCircle, Phone } from 'lucide-react';

const SupportCard = () => {
  return (
    <div className="card p-6 border-l-4 border-l-primary">
      <div className="flex items-center gap-2 mb-4">
        <Headphones size={20} className="text-primary" />
        <h3 className="font-semibold text-text-primary">Soporte Técnico</h3>
        <span className="badge-success ml-auto">
          <CheckCircle size={12} className="mr-1" />
          Operativo
        </span>
      </div>

      <p className="text-sm text-text-secondary mb-4">
        ¿Necesitas ayuda técnica? Nuestro equipo de IT está disponible para asistirte.
      </p>

      <div className="flex flex-col gap-3">
        <a
          href="mailto:techsupport@sonneil.com"
          className="flex items-center gap-3 p-3 rounded-lg bg-background hover:bg-primary-lighter/30 transition-colors group"
        >
          <Mail size={18} className="text-primary" />
          <div className="flex-1">
            <p className="text-sm font-medium text-text-primary">techsupport@sonneil.com</p>
            <p className="text-xs text-text-tertiary">Crear ticket de soporte</p>
          </div>
        </a>

        <a
          href="tel:+34695847348"
          className="flex items-center gap-3 p-3 rounded-lg bg-error/5 hover:bg-error/10 transition-colors group border border-error/20"
        >
          <Phone size={18} className="text-error" />
          <div className="flex-1">
            <p className="text-sm font-medium text-text-primary">695 847 348</p>
            <p className="text-xs text-error">Emergencias - Edwin (Microinformático)</p>
          </div>
        </a>

        <a
          href="https://help.sonneil.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 p-3 rounded-lg bg-background hover:bg-primary-lighter/30 transition-colors group"
        >
          <ExternalLink size={18} className="text-info" />
          <div className="flex-1">
            <p className="text-sm font-medium text-text-primary">Sonneil Wiki</p>
            <p className="text-xs text-text-tertiary">Base de conocimiento completa</p>
          </div>
        </a>
      </div>
    </div>
  );
};

export default SupportCard;


